import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class RoadmapTableIndexController extends Controller {
  @service router;
  @service favorite;
  @service store;
  @service('beta-toggle') betaService;
  @service('organisation') orgService;
  @service intl;
  @service initiativeSlideover;
  @service betaToggle;

  @tracked showFilterSlideover = false;

  @tracked search = '';

  @tracked initiativeFormIsVisible = false;

  @service tracker;

  queryParams = [
    'grouping',
    'statuses',
    'themes',
    'sources',
    'productManagers',
    'teams',
    'roadmaps',
    'columns',
    'goals',
    'search',
    'tableSort',
  ];

  @tracked grouping = null;
  @tracked statuses = [];
  @tracked themes = [];
  @tracked sources = [];
  @tracked productManagers = [];
  @tracked teams = [];
  @tracked columns = [];
  @tracked roadmaps = [];
  @tracked goals = [];

  @tracked tableSort = '';
  @tracked list = [];

  @action
  onGroupingSelect(e) {
    this.grouping = e.value;
  }

  @action
  onStatusSelect(e) {
    this.status = e;
  }

  @action
  onThemeSelect(e) {
    this.themes = e;
  }

  @action
  onSourceSelect(e) {
    this.sources = e;
  }

  @action
  onPmSelect(e) {
    this.productManagers = e;
  }

  @action
  onTeamSelect(e) {
    this.teams = e;
  }

  @action
  handleRoadmapSelect(roadmaps) {
    this.roadmaps = roadmaps;
  }

  @action
  handleFilterDelete(filter) {
    const param = filter.key;
    const filters = this[param];
    if (Array.isArray(filters))
      this[param] = filters.filter((item) => item !== filter.value);
    else this[param] = null;
  }

  get columnOptions() {
    const columns = [...this.betaToggle.columnOptions];
    columns.forEach((item) => {
      item.show = this.showColumn(item);
    });
    return columns.slice();
  }

  showColumn(column) {
    if (this.columns.length === 0) {
      if (column.show !== undefined) return column.show;
      return true;
    } else {
      return this.columns.includes(column.label);
    }
  }

  @action
  toggleInitiativeForm(val) {
    if (val !== undefined) this.initiativeFormIsVisible = val;
    else this.initiativeFormIsVisible = !this.initiativeFormIsVisible;
  }

  get initiatives() {
    return this.store.peekAll('initiative');
  }

  @action
  onColumnSelect(values) {
    this.columns = values;
  }

  @action
  setSearch(e) {
    this.search = e;
  }
}
